import * as React from 'react';

import { MessageBar, MessageBarType, Spinner, SpinnerSize } from '@fluentui/react';

import { Claim } from '../../redux/claim/types';
import { VisitSidePanel } from '../visit/VisitSidePanel';
import { AsyncData } from '../../redux/core';
import { Visit as VisitData } from '../../redux/visits/types';
import { connect } from 'react-redux';
import { RootState } from '../../redux/types';
import { Dispatch, bindActionCreators } from 'redux';
import { fetchOnSiteVisit } from '../../redux/on-site-manager/on-site-visits/actions';
import { fetchVisit } from '../../redux/visits/actions';

interface OwnProps {
  visitCode: string;
  visitSideCardClaim?: Claim;
  hideCloseIcon?: boolean;
  onClose?: () => void;
  showReferralPanel?: boolean;
  zendeskTicketId?: string;
  hideMap?: boolean;
}

interface StateProps {
  visits: AsyncData<VisitData[]>;
  visitCodeToVisitIndex: { [code: string]: number };
}

interface DispatchProps {
  actions: {
    fetchVisit: (visitCode: string, refresh?: boolean) => void;
    fetchOnSiteVisit: (visitCode: string, refresh?: boolean) => void;
  };
}

type AsyncVisitSidePanelProps = OwnProps & StateProps & DispatchProps;

interface AsyncVisitSidePanelState {
  loading?: boolean;
}

class Component extends React.Component<AsyncVisitSidePanelProps, AsyncVisitSidePanelState> {
  constructor(props: AsyncVisitSidePanelProps) {
    super(props);
    this.state = {};
  }

  public componentDidMount() {
    this.fetchVisit(this.props.visitCode);
  }

  public componentDidUpdate(prevProps: AsyncVisitSidePanelProps) {
    if (this.props.visitCode !== prevProps.visitCode) {
      this.fetchVisit(this.props.visitCode);
    }

    if (prevProps.visits.isFetching && !this.props.visits.isFetching) {
      this.setState({ loading: false });
    }
  }

  public render(): JSX.Element {
    const { visitCodeToVisitIndex, visits, visitCode, hideCloseIcon, onClose } = this.props;
    const visit = visits.data?.[visitCodeToVisitIndex[visitCode]];

    if (this.state.loading) {
      return <Spinner style={{ marginTop: 20 }} label={`Loading visit ${visitCode}...`} size={SpinnerSize.large} />;
    } else {
      if (!visit) {
        return (
          <MessageBar messageBarType={MessageBarType.error} isMultiline={true}>
            {`The visit ${visitCode} was not found.`}
          </MessageBar>
        );
      }

      return (
        <VisitSidePanel
          hideCloseIcon={hideCloseIcon}
          onClose={onClose}
          visit={visit}
          hideMap={this.props.hideMap}
          showReferralPanel={this.props.showReferralPanel}
          zendeskTicketId={this.props.zendeskTicketId}
        />
      );
    }
  }

  private fetchVisit(visitCode: string) {
    this.setState({ loading: true });
    if (visitCode.indexOf('XX') === 0) {
      this.props.actions.fetchOnSiteVisit(visitCode);
    } else {
      this.props.actions.fetchVisit(visitCode);
    }
  }
}

export function mapStateToProps(state: RootState): StateProps {
  const isOnSiteVisit = state.ui.visitCode.indexOf('XX') === 0;
  return {
    visits: isOnSiteVisit ? state.onSiteManager.onSiteVisits.onSiteVisits : state.visits.visits,
    visitCodeToVisitIndex: isOnSiteVisit ? state.onSiteManager.onSiteVisits.onSiteVisitCodeToVisitIndex : state.visits.visitCodeToVisitIndex,
  };
}

export function mapDispatchToProps(dispatch: Dispatch): DispatchProps {
  return {
    actions: bindActionCreators({ fetchOnSiteVisit, fetchVisit }, dispatch),
  };
}

export const AsyncVisitSidePanel = connect<StateProps, DispatchProps, OwnProps, RootState>(mapStateToProps, mapDispatchToProps)(Component);
